export default __webpack_public_path__ + "static/media/ico-sq-14-fish.5c27df7e.svg";